"use client";

import Image from "next/image";
import Link from "@/components/ui/Link";
import LiveBlink from "@/components/ui/LiveBlink";
import { isLiveBlogValue } from "@/lib/liveBlog";
import { MessageIcon } from "../ui/message-icon";
import { BOOKMARK_CATEGORIES } from "@/lib/api/public-client";
import { FALLBACK_IMAGE } from '@/lib/constants';
import { getImageUrl, getTimeAgo, getFocusPointStyle, toFieldString, ImageMetadata, BLUR_PLACEHOLDER } from '@/lib/componentutills';

type FieldConfig = {
  hidden?: boolean;
  value?: string | boolean;
  customClass?: string;
};

type Props = {
  title?: FieldConfig;
  timeAgo?: FieldConfig;
  imageSrc?: FieldConfig;
  slug?: string;
  priority?: boolean;
  imageMetadata?: ImageMetadata;
  templatetype?: FieldConfig;
  isliveblog?: FieldConfig;
};

export const VerticalSmallImageNews = ({
  title = { hidden: false, value: "பெண் பார்க்க போன வெற்றிக்கு ஷக்தி வைத்த ட்விஸ்ட்.!", customClass: "" },
  timeAgo = { hidden: false, value: "30 min ago", customClass: "" },
  imageSrc = { hidden: false, value: undefined, customClass: "" },
  slug,
  priority = false,
  imageMetadata,
  templatetype = { hidden: false, value: "", customClass: "" },
  isliveblog = { hidden: false, value: "", customClass: "" },
}: Props) => {
  const titleValue = toFieldString(title?.value);
  const timeAgoValue = getTimeAgo(toFieldString(timeAgo?.value));
  const validImageSrc = getImageUrl(toFieldString(imageSrc?.value)) || FALLBACK_IMAGE;
  const isLiveBlog = isLiveBlogValue(templatetype?.value) || isLiveBlogValue(isliveblog?.value);
  const content = (
    <div className="flex flex-col bg-F8F8F8 overflow-hidden p-4 gap-4">
      {/* IMAGE */}
      {!imageSrc?.hidden && (
        <div className={imageSrc?.customClass || ""}>
          <div className="relative w-full aspect-[16/9] overflow-hidden">
            <Image
              src={validImageSrc}
              alt={titleValue}
              fill
              className="object-cover w-full h-full"
              style={getFocusPointStyle(imageMetadata)}
              loading={priority ? "eager" : "lazy"}
              fetchPriority={priority ? "high" : "auto"}
              priority={priority}
              sizes="(max-width: 768px) 100vw, (max-width: 1200px) 33vw, 300px"
              placeholder="blur"
              blurDataURL={BLUR_PLACEHOLDER}
            />
          </div>
        </div>
      )}

      {/* CONTENT */}
      <div className="flex flex-col gap-3">

        {/* Title */}
        {!title?.hidden && (
 <h3 className={` text-14-tamil-700 leading-[1.4] text-1B1B1B h-auto ${title?.customClass || ""}`}>
            {isLiveBlog && (
              <LiveBlink />
            )}
            {titleValue}
          </h3>
        )}

        {/* Footer */}
        <div className="flex justify-between items-center gap-3">
          {/* {!timeAgo?.hidden && (
            <span className={`text-12-tamil-500 text-1B1B1B ${timeAgo?.customClass || ""}`}>{timeAgoValue}</span>
          )} */}
          <MessageIcon
            id="message-icon-1"
            slug={slug}
            category={BOOKMARK_CATEGORIES.NEWS}
            title={titleValue}
            thumbnailUrl={validImageSrc}
            articleUrl={slug ? `/${slug}` : undefined}
          />
        </div>
      </div>
    </div>
  );

  if (slug) {
    return (
      <Link href={`/${slug}`} className="block hover:bg-gray-100 transition-colors cursor-pointer">
        {content}
      </Link>
    );
  }

  return content;
};
